import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import Img from "../../../images/podcast/ep-1.png";
import {LazyLoadImage} from "react-lazy-load-image-component";


function Banner({data}) {
    return (

        <div className="services_banner ">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={7} lg={7} xl={7} xxl={7} className="my-auto">
                        <div className="example" data-text="Tek Podcast">
                            <h1>Guardian Angel – A lesson in saving lives using a mobile app</h1>
                        </div>
                        <div
                            className="banner_content_txt listing_flex">
                            <p>In Episode #03 our host was Mr. JR Ridge, actor, producer, and the entrepreneur who founded Guardian Angel discusses the hardship of starting a business from scratch with no investment and how you can do it too in a way that gives back to society, and save lives. The conversation goes from discussing the journey of JR coming to the US as a baby adopted from the Philippines, his journey into entrepreneurship, and his perspective on the role of tech in helping him give back to the society using Guardian Angel, an automotive alert app that is literally made to just save lives.</p>
                        </div>
                    </Col>
                    <Col xs={12} md={5} lg={5} xl={5} xxl={5} className="my-auto text-center">
                        <LazyLoadImage
                            src={Img}
                            effect="blur" alt="Image" className="img-fluid"
                        />
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Banner;